<template>
  <svg class="app-loading-icon" :width="cSize" :height="cSize" viewBox="25 25 50 50" :stroke="cColor">
    <circle
      class="app-loading-icon__path"
      cx="50"
      cy="50"
      r="20"
      fill="none"
      :stroke-width="strokeWidth"
      stroke-miterlimit="10"
    />
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  size: {
    type: String,
    default: '80',
  },
  color: {
    type: String,
    default: 'cas-button',
  },
})

const cSize = computed(() => {
  return props.size
})
const cColor = computed(() => {
  const color = props.color
  if (color && !color.startsWith('#') && !color.startsWith('rgb') && !color.startsWith('hsl')) {
    const variableColor = getComputedStyle(document.documentElement).getPropertyValue(`--${color}`).trim()
    return variableColor || 'currentColor'
  }
  return color || 'currentColor'
})
const strokeWidth = computed(() => {
  return Number(props.size) / 16
})
</script>

<style lang="scss">
.app-loading-icon {
  animation: spinner 2s linear infinite;

  &__path {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
    animation: spinner-path 1.5s ease-in-out infinite;
  }
}

@keyframes spinner {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinner-path {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
</style>
